/* eslint-disable */
const elLang = require('element-plus/lib/locale/lang/zh-cn')

module.exports = {   
  languageName: '中文简体',
  ...elLang.default,  
  companyName: '上海境腾信息科技有限公司',  
  invalidRoute: '访问路径错误，请检查',
  login: {
    title: '设备验证',
    usernamePlaceholder: '用户名',
    passwordPlaceholder: '密码',
    sendAuth: "发送验证码",
    inputAuthCode: "输入验证码",
    login: "登录",
    inputUsername: "请输入您的用户",
    inputPassword: "请输入您的密码",    
    tip3: '密码不能少于8位',
    sendMessage: '发送验证码',
    loginBtn: '登录',
    techName: '境腾SaaS',
    tipText: '验证码已发送',
    needStrongPass: '你的密码不满足系统密码复杂度要求，请修改后再继续',
    tip: '提示',
    submit: '确定',
    passwordError: '账号或密码错误',
    passwordErrorExceedLimitation: '用户名密码错误多次，账号被锁定15分钟',
    pemissionDeny: "您无权登录本系统",
    loginError: "登陆错误，请检查网络",
    authcodeError: "验证码错误",
    noUserNote: '没有用户？',
    registNow: '立即注册',
    logoutBtn: '登出'
  },  
  regist: {
    title: '创建账号',
    usernamePlaceholder: '输入登录名',
    passwordPlaceholder: '输入登录密码',
    confirmPasswordPlaceholder: '再次输入登录密码',
    telPlaceholder: '输入邮箱或手机号',
    authcodePlaceholder: '验证码',
    sendAuth: "获取验证码",
    registBtn: '注册',
    privacyNote: '我已阅读并同意《境腾用户协议》和《隐私协议》',
    usernameTip: '5-25字符，可以包含字母或者汉字',
    passwordTip: '密码设置不符合要求',
    confirmPasswordTip: '两次输入的密码不一致，请重新输入',
    telTip: '请输入手机号或邮箱号',
    authcodeTip: '输入验证码',
    agreementNote: `我已阅读并同意`,
    agreementNote1: '和',
    privacyNote: '《隐私协议》',
    EULANote: '《境腾用户协议》',
    strongPassNote: '密码最小8位，包含大小写和数字以及符号',
    agreementTip: '请确认您同意协议',
    userExistsTip: '用户已存在，请直接登录',
    registSuccessful: '注册成功，请登录',
    userExists: '用户已存在，请选择其他手机/邮箱号码',
    authcodeSent: '验证码已发送',
    authcodeError: '验证码发送错误，请稍候重试',
    registFailed: '申请失败，请刷新重试',
    confirmPassNotMatch: '两次输入的密码不一致，请重新输入',
    success: '注册成功',
    goLogin: '去登陆',
    links: '产品链接',
    beamlink: 'Beamlink',
    jtworkflow: 'JTWorkflow',
    jtra: 'JTRA'

  },  
  sicialSignin:{
    aadGlobal: 'Azure AD登录(全球)',
    aadChina: 'Azure AD登录(中国)',
    addTenantNotFound: '找不到对应的Azure AD租户。请联系您的租户管理员绑定Azure AD租户',
    aadLoginError: 'AAD账号登录错误'
  },
  twoFactor: {
    title: '双重验证',
    note: '请点击获取验证码，在下方填写您收到的验证码并确认登录。',
    authcodePlaceholder: '请输入短信验证码',
    sendAuthcode: '获取验证码',
    ok: '确定'
  },  
  codeView: {
    title: '设备登录',
    note: '请输入设备上显示的9位数字',
    confirm: '提交',
    codeRequire: '请完整输入9位用户码',
    varified: '验证成功',
    codeError: '提交错误，请重新输入'
  },
  errorView: {
    title: '出错了！',
    note: '出错了！请检查输入的地址后缀'
  },
  noteView: {
    success: '验证成功！' ,
    note: '返回设备继续',
    logout: "退出登录",
    verifyAgain: "再次验证"
  }
};
